import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/name-numerology-calculator/page.tsx");
